import { E164Number, parsePhoneNumberWithError } from 'libphonenumber-js';
export default class PhoneNumber {
  private readonly _value: string;

  constructor(value: string | E164Number) {
    this._value = value;
  }
  public get value(): string {
    return this._value;
  }
  public static fromJSON(value: string) {
    if (!value) return;
    return new PhoneNumber(value);
  }
  public toE164Number(): E164Number {
    return parsePhoneNumberWithError(this._value).number;
  }
  public toJSON(): string {
    return this._value;
  }
}
